(function () {
  class MixAndMatch {
    constructor(root) {
      this.root = root;
      this.pickCount = parseInt(root.dataset.pickCount, 10) || 3;
      this.freeCount = parseInt(root.dataset.freeCount, 10) || 1;
      this.discountCode = (root.dataset.discountCode || '').trim();
      this.moneyFormat = window.shopifyMoneyFormat || window.moneyFormat || '&pound;{{amount}}';
      this.items = [];

      this.slotsEl = root.querySelector('[data-mm-slots]');
      this.addBtn = root.querySelector('[data-mm-add]');
      this.subtotalEl = root.querySelector('[data-mm-subtotal]');
      this.savingsEl = root.querySelector('[data-mm-savings]');
      this.totalEl = root.querySelector('[data-mm-total]');
      this.statusEl = root.querySelector('[data-mm-status]');

      if (!this.slotsEl || !this.addBtn) return;

      this.bind();
      this.render();
    }

    bind() {
      this.root.querySelectorAll('[data-mm-product]').forEach((card) => {
        card.querySelectorAll('[data-mm-add-item]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.addItemFromCard(card);
          });
        });
      });

      this.slotsEl.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-mm-remove]');
        if (!removeBtn) return;
        const idx = parseInt(removeBtn.dataset.mmRemove, 10);
        this.removeAt(idx);
      });

      this.addBtn.addEventListener('click', () => this.submit());
    }

    addItemFromCard(card) {
      const productId = card.dataset.productId;
      const existingIdx = this.items.findIndex((i) => i.productId === productId);
      if (existingIdx !== -1) {
        this.items.splice(existingIdx, 1);
        this.render();
        return;
      }

      if (this.items.length >= this.pickCount) {
        this.flashStatus('Your mix is full. Remove one to swap.');
        return;
      }

      this.items.push({
        productId: productId,
        variantId: card.dataset.variantId,
        title: card.dataset.title,
        image: card.dataset.image,
        price: parseInt(card.dataset.price, 10) || 0,
        url: card.dataset.url
      });

      this.render();
    }

    removeAt(idx) {
      this.items.splice(idx, 1);
      this.render();
    }

    calc() {
      const prices = this.items.map((i) => i.price);
      const sorted = [...prices].sort((a, b) => a - b);
      const subtotal = prices.reduce((a, b) => a + b, 0);
      let savings = 0;
      if (this.items.length >= this.pickCount) {
        savings = sorted.slice(0, this.freeCount).reduce((a, b) => a + b, 0);
      }
      return { subtotal, savings, total: subtotal - savings };
    }

    format(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, this.moneyFormat);
      }
      return '\u00A3' + (cents / 100).toFixed(2);
    }

    escape(s) {
      return String(s).replace(/[&<>"']/g, (c) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[c]));
    }

    render() {
      const slotEls = this.slotsEl.querySelectorAll('.mix-match__slot');

      // Figure out which items are the cheapest (free) once the mix is full,
      // then build a display order that places the free items last.
      let freeItemIndices = [];
      if (this.items.length >= this.pickCount) {
        freeItemIndices = this.items
          .map((it, i) => ({ i, price: it.price }))
          .sort((a, b) => a.price - b.price)
          .slice(0, this.freeCount)
          .map((o) => o.i);
      }

      const freeSet = new Set(freeItemIndices);
      const paidOrder = this.items
        .map((_, i) => i)
        .filter((i) => !freeSet.has(i));
      const displayOrder = paidOrder.concat(freeItemIndices);

      slotEls.forEach((slot, slotIdx) => {
        const itemIdx = displayOrder[slotIdx];
        const item = itemIdx != null ? this.items[itemIdx] : null;
        slot.classList.toggle('is-filled', !!item);
        slot.classList.toggle('is-free', item != null && freeSet.has(itemIdx));

        if (item) {
          slot.innerHTML =
            '<div class="mix-match__slot-filled">' +
              '<img src="' + this.escape(item.image) + '" alt="" class="mix-match__slot-img">' +
              '<div class="mix-match__slot-text">' +
                '<span class="mix-match__slot-title">' + this.escape(item.title) + '</span>' +
                '<span class="mix-match__slot-price">' + this.format(item.price) + '</span>' +
              '</div>' +
              '<button type="button" class="mix-match__slot-remove" data-mm-remove="' + itemIdx + '" aria-label="Remove from mix">&times;</button>' +
            '</div>';
        } else {
          slot.innerHTML =
            '<div class="mix-match__slot-empty">' +
              '<span class="mix-match__slot-num">' + (slotIdx + 1) + '</span>' +
              '<span class="mix-match__slot-label">Add a fragrance</span>' +
            '</div>';
        }
      });

      const { subtotal, savings, total } = this.calc();
      if (this.subtotalEl) this.subtotalEl.textContent = this.format(subtotal);
      if (this.savingsEl) this.savingsEl.textContent = this.format(savings);
      if (this.totalEl) this.totalEl.textContent = this.format(total);

      const ready = this.items.length === this.pickCount;
      this.addBtn.disabled = !ready;

      if (this.statusEl) {
        if (ready) {
          this.statusEl.textContent = 'Your mix is ready. Add to bag!';
        } else {
          const remaining = this.pickCount - this.items.length;
          this.statusEl.textContent =
            'Pick ' + remaining + ' more ' + (remaining === 1 ? 'fragrance' : 'fragrances') + ' to unlock the offer.';
        }
      }

      this.root.querySelectorAll('[data-mm-product]').forEach((card) => {
        const id = card.dataset.productId;
        const count = this.items.filter((i) => i.productId === id).length;
        const countEl = card.querySelector('[data-mm-count]');
        if (countEl) {
          countEl.textContent = count > 0 ? 'x' + count : '';
          countEl.setAttribute('data-empty', count === 0 ? 'true' : 'false');
        }
        card.classList.toggle('is-in-mix', count > 0);
        const addLabel = card.querySelector('.mix-match__card-btn-add');
        if (addLabel) {
          addLabel.textContent = count > 0 ? 'Remove from mix' : '+ Add to mix';
        }
      });
    }

    flashStatus(text) {
      if (!this.statusEl) return;
      this.statusEl.textContent = text;
      clearTimeout(this._flashT);
      this._flashT = setTimeout(() => this.render(), 2500);
    }

    setAddBtnText(text) {
      const span = this.addBtn.querySelector('span');
      if (span) {
        span.textContent = text;
      } else {
        this.addBtn.textContent = text;
      }
    }

    getAddBtnText() {
      const span = this.addBtn.querySelector('span');
      return span ? span.textContent : this.addBtn.textContent;
    }

    async submit() {
      if (this.items.length !== this.pickCount) return;

      const originalText = this.getAddBtnText();
      this.addBtn.disabled = true;
      this.addBtn.classList.add('loading');
      this.setAddBtnText('Adding\u2026');

      try {
        const payload = {
          items: this.items.map((it) => ({
            id: Number(it.variantId),
            quantity: 1
          }))
        };

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || 'Add to cart failed');
        }

        if (this.discountCode) {
          window.location.href =
            '/discount/' + encodeURIComponent(this.discountCode) + '?redirect=/cart';
          return;
        }

        await this.refreshCart();

        this.items = [];
        this.render();
        this.setAddBtnText('Added \u2713');
        setTimeout(() => {
          this.setAddBtnText(originalText);
          this.render();
        }, 1800);
      } catch (err) {
        console.error('[mix-and-match] add failed', err);
        this.setAddBtnText('Error \u2013 try again');
        setTimeout(() => {
          this.setAddBtnText(originalText);
          this.render();
        }, 2200);
      } finally {
        this.addBtn.classList.remove('loading');
      }
    }

    async refreshCart() {
      try {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await res.json();
        document
          .querySelectorAll('[data-cart-count], .cart-count-bubble span')
          .forEach((n) => {
            n.textContent = cart.item_count;
          });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));

        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        }
      } catch (e) {
        console.warn('[mix-and-match] cart refresh failed', e);
      }
    }
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-mix-match]').forEach((root) => {
      if (root.dataset.mmInit === '1') return;
      root.dataset.mmInit = '1';
      new MixAndMatch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target || document));
})();
